import React from "react";

import Box from "@material-ui/core/Box";
import Fade from "@material-ui/core/Fade";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";

import StatusChip from "./StatusChip";
import PlaceIcon from "@material-ui/icons/Place";

export default React.memo(function SearchResults({ results, onResultClick, a11y }) {
  return (
    <Fade in={results.length > 0}>
      <Box overflow="scroll" height="100%" pl={2} pr={2} pb={2}>
        <Paper>
          <List>
            {results.map((result, i) => (
              <React.Fragment key={`${result.id}-${i}}`}>
                <ListItem button onClick={() => onResultClick(result)}>
                  <ListItemIcon>
                    <PlaceIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={result.display1.replace(/Property (\d*): /, "")}
                    secondary={
                      result.entity === "lyr_property" ? (
                        result.display2
                      ) : (
                        <StatusChip status={result.display2} a11y={a11y} />
                      )
                    }
                  />
                </ListItem>
                {i + 1 !== results.length && (
                  <Divider variant="inset" component="li" />
                )}
              </React.Fragment>
            ))}
          </List>
        </Paper>
      </Box>
    </Fade>
  );
}, ({results:prev}, {results:next}) => JSON.stringify(prev) === JSON.stringify(next))
